/**
 * Foremark 客户端多语言 — 店铺仅发布一种语言时，不跳转 URL，直接切换主题文案
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'foremark-locale';
  var LOCALES = ['ja', 'en', 'zh', 'ko'];
  var cache = {};

  function normalizeLocale(code) {
    if (!code) return 'ja';
    if (code === 'zh-CN' || code === 'zh-cn' || code === 'zh') return 'zh';
    return code.split('-')[0];
  }

  function getStoredLocale() {
    var stored = normalizeLocale(localStorage.getItem(STORAGE_KEY));
    return LOCALES.indexOf(stored) >= 0 ? stored : 'ja';
  }

  function assetUrlForLocale(locale) {
    var assets = window.ForemarkI18nAssets || {};
    return assets[locale] || assets.ja;
  }

  function loadLocale(locale) {
    locale = normalizeLocale(locale);
    if (cache[locale]) return Promise.resolve(cache[locale]);
    var url = assetUrlForLocale(locale);
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cache[locale] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  function setText(sel, text) {
    var el = document.querySelector(sel);
    if (el && text != null) el.textContent = text;
  }

  function setHtml(sel, html) {
    var el = document.querySelector(sel);
    if (el && html != null) el.innerHTML = html;
  }

  function applyNav(data) {
    var n = data.nav || {};
    document.querySelectorAll('.fm-nav-link, .fm-mobile-nav-link').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href === '/' || href.endsWith('/')) {
        if (n.home) link.textContent = n.home;
      } else if (href.indexOf('/pages/product') !== -1 || href.indexOf('/products/') !== -1) {
        if (n.product) link.textContent = n.product;
      } else if (href.indexOf('/pages/clubs') !== -1) {
        if (n.clubs) link.textContent = n.clubs;
      } else if (href.indexOf('/pages/craft') !== -1) {
        if (n.craft) link.textContent = n.craft;
      } else if (href.indexOf('/pages/contact') !== -1) {
        if (n.contact) link.textContent = n.contact;
      }
    });
    var langLabel = document.querySelector('.fm-mobile-lang-label');
    if (langLabel && n.language) langLabel.textContent = n.language;
  }

  function applyFooter(data) {
    var f = data.footer || {};
    setText('.footer-brand p', f.tagline);
    document.querySelectorAll('.footer-col h4').forEach(function (h4, i) {
      var keys = [f.shop_heading, f.support_heading, f.company_heading];
      if (keys[i]) h4.textContent = keys[i];
    });
    var shopCol = document.querySelectorAll('.footer-col')[1];
    if (shopCol) {
      var links = shopCol.querySelectorAll('a');
      if (links[0] && f.bag_tag) links[0].textContent = f.bag_tag;
      if (links[1] && f.double_sided) links[1].textContent = f.double_sided;
      if (links[2] && f.clubs_order) links[2].textContent = f.clubs_order;
    }
    var supportCol = document.querySelectorAll('.footer-col')[2];
    if (supportCol) {
      var sLink = supportCol.querySelector('a[href*="contact"]');
      if (sLink && f.contact) sLink.textContent = f.contact;
    }
    var bottom = document.querySelector('.footer-bottom');
    if (bottom) {
      var spans = bottom.querySelectorAll('span');
      if (spans[0] && f.copyright) spans[0].textContent = f.copyright;
      if (spans[1] && f.made_in) spans[1].textContent = f.made_in;
    }
  }

  function syncEngraveTranslations(locale, data) {
    if (!window.ForemarkTheme) window.ForemarkTheme = {};
    var e = data.engrave || {};
    var p = data.product || {};
    window.ForemarkTheme.locale = locale === 'zh' ? 'zh-CN' : locale;
    window.ForemarkTheme.translations = window.ForemarkTheme.translations || {};
    window.ForemarkTheme.translations.product = {
      addToCart: p.add_to_cart,
      addedToCart: p.added_to_cart,
      soldOut: p.sold_out,
      view_cart: p.view_cart,
      error_add: p.error_add,
      addon_note: p.addon_note
    };
    window.ForemarkTheme.translations.placeholders = {
      club: e.placeholder_club_short,
      name: e.placeholder_name_short,
      number: e.placeholder_number_short
    };
    window.ForemarkTheme.translations.templateSamples = {
      classic: { club: e.sample_club, name: e.sample_name, number: e.sample_number },
      minimal: { club: e.sample_club, name: e.sample_name_en, number: '' },
      monogram: { club: e.sample_club, name: e.sample_name, number: e.sample_number },
      club: { club: 'TOKYO GOLF CLUB', name: '', number: 'Member 1288' },
      elegant: { club: 'FOREMARK GOLF', name: 'Hanako S.', number: 'No. 007' },
      modern: { club: 'GOLF CLUB', name: 'Suzuki Ken', number: '#2048' }
    };
    window.ForemarkTheme.translations.sizes = e.sizes || {};
  }

  function applyProductPage(data) {
    var h = data.home || {};
    var p = data.product || {};
    var e = data.engrave || {};
    var c = data.colors || {};
    var t = data.trust || {};

    setText('.announce', data.announce);
    setText('.intro-tag', h.eyebrow);
    setHtml('.intro-strip h1', h.hero_title_html);
    setHtml('.intro-strip p', h.hero_subtitle_html);
    setText('.preview-label', e.preview_label);
    setText('.tag-size-hint', e.size_hint);
    setText('.product-title', h.product_name);
    setText('.product-subtitle', h.product_subtitle);
    setText('.rating a', h.reviews_count);
    setText('.price-note', p.tax_included);
    setText('.price-badge', p.free_shipping);

    var colorLabel = document.querySelector('.option-label');
    if (colorLabel && p.color_label) {
      var selected = document.getElementById('selected-color');
      var selectedText = selected ? selected.textContent : '';
      colorLabel.innerHTML = p.color_label + ' <span id="selected-color">' + selectedText + '</span>';
    }

    var swatchMap = { black: c.black, gold: c.gold, green: c.green, red: c.red, blue: c.blue };
    document.querySelectorAll('.swatch').forEach(function (btn) {
      var key = btn.dataset.key;
      if (swatchMap[key]) {
        btn.dataset.name = swatchMap[key];
        btn.title = swatchMap[key];
      }
    });

    document.querySelectorAll('.color-card').forEach(function (card) {
      var key = card.dataset.key;
      var h4 = card.querySelector('h4');
      if (h4 && c[key]) h4.textContent = c[key];
    });

    var addBtn = document.getElementById('add-to-cart-btn');
    if (addBtn && p.add_to_cart) addBtn.textContent = p.add_to_cart;
    var buyBtn = document.getElementById('buy-now-btn');
    if (buyBtn && p.buy_now) buyBtn.textContent = p.buy_now;

    document.querySelectorAll('.trust-strip-item').forEach(function (item, i) {
      var rows = [
        [t.shipping_title, t.shipping_desc],
        [t.delivery_title, t.delivery_desc],
        [t.made_title, t.made_desc],
        [t.order_title, t.order_desc]
      ];
      if (!rows[i]) return;
      var strong = item.querySelector('strong');
      var span = item.querySelector('span');
      if (strong) strong.textContent = rows[i][0];
      if (span) span.textContent = rows[i][1];
    });

    syncEngraveTranslations(normalizeLocale(localStorage.getItem(STORAGE_KEY)), data);
  }

  function applyLocale(locale) {
    return loadLocale(locale).then(function (data) {
      if (!data) return;
      locale = normalizeLocale(locale);
      localStorage.setItem(STORAGE_KEY, locale);
      document.documentElement.lang = locale === 'zh' ? 'zh-CN' : locale;

      applyNav(data);
      applyFooter(data);
      setText('.announce', data.announce);

      if (document.body.classList.contains('foremark-product')) {
        applyProductPage(data);
      }

      document.querySelectorAll('[data-foremark-locale]').forEach(function (btn) {
        var active = normalizeLocale(btn.getAttribute('data-foremark-locale')) === locale;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      document.dispatchEvent(new CustomEvent('foremark:locale', { detail: { locale: locale, data: data } }));
    });
  }

  function initClientSwitcher() {
    if (!window.ForemarkI18nClientSide) return;

    document.querySelectorAll('[data-foremark-locale]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        applyLocale(btn.getAttribute('data-foremark-locale'));
      });
    });

    var initial = getStoredLocale();
    var serverLocale = normalizeLocale(document.documentElement.lang || 'ja');
    if (initial !== serverLocale) {
      applyLocale(initial);
    }
  }

  window.ForemarkI18n = { applyLocale: applyLocale, getLocale: getStoredLocale };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClientSwitcher);
  } else {
    initClientSwitcher();
  }
})();
